import { calculateCalibrationTotals } from 'src/app/Shared/calibration-invoice-totals';
import { Component, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { finalize } from 'rxjs/operators';
import {
  CalibrationConfirmInvoiceApiResponse,
  CalibrationConfirmInvoiceDeviceModel,
  CalibrationConfirmInvoiceModel
} from 'src/app/Interface/CalibrationConfirmInvoice_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CalibrationConfirmInvoiceService } from 'src/app/Service/CalibrationConfirmInvoice.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import {
  calculateCalibrationFinalTotal,
  calculateCalibrationInvoiceTotal,
  calculateCalibrationUnitPrice
} from 'src/app/Shared/calibration-confirm-invoice-price';

@Component({
  selector: 'app-calibration-confirm-invoice-form',
  templateUrl: './CalibrationConfirmInvoiceForm.component.html',
  styleUrls: ['./CalibrationConfirmInvoiceForm.component.scss']
})
export class CalibrationConfirmInvoiceFormComponent implements OnInit {
  calibrationId = 0;
  receipt: CalibrationConfirmInvoiceModel | null = null;
  details: CalibrationConfirmInvoiceDeviceModel[] = [];
  takhfif = 0;
  arshAfzoodeh = 0;
  khadamat = 0;
  totals = calculateCalibrationTotals([], 0, 0, 0);
  InProccessing = false;
  savingIndex: number | null = null;
  confirming = false;
  private savedDetails = new Map<number, string>();

  get hasUnsavedChanges(): boolean {
    return this.details.some(item => this.savedDetails.get(item.id) !== JSON.stringify(item));
  }
  confirmModalRef: any;

  constructor(
    private route: ActivatedRoute,
    private service: CalibrationConfirmInvoiceService,
    private Nav_Service: NavService,
    private alertifyService: AlertifyService,
    private router: Router,
    private modalService: BsModalService
  ) { }

  ngOnInit(): void {
    this.calibrationId = Number(this.route.snapshot.paramMap.get('id'));
    this.receipt = history.state && history.state.receipt ? history.state.receipt : null;
    if (!this.calibrationId) {
      this.alertifyService.ErrorMessage('شماره رسید معتبر نیست.');
      return;
    }

    this.Nav_Service.CheckValidPage(2242).subscribe(
      () => this.readDetail(),
      () => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    );
  }

  readDetail(): void {
    this.InProccessing = true;
    this.service.GetInvoiceDetail(this.calibrationId)
      .pipe(finalize(() => this.InProccessing = false))
      .subscribe(
        response => {
          this.details = response.devices;
          this.savedDetails = new Map(this.details.map(item => [item.id, JSON.stringify(item)]));
          this.takhfif = response.takhfif;
          this.arshAfzoodeh = response.arshAfzoodeh;
          this.khadamat = response.khadamat;
          this.calculateTotals();
          this.totals = response.totals;
        },
        () => this.alertifyService.ErrorMessage('دریافت جزئیات رسید با خطا مواجه شد.')
      );
  }

  saveDetail(item: CalibrationConfirmInvoiceDeviceModel, index: number): void {
    if (this.savingIndex !== null || this.confirming) {
      return;
    }

    const model = {
      id: item.id,
      incRail: item.incRail,
      incRailPercent: item.incRailPercent,
      incT4: item.incT4,
      incT4Percent: item.incT4Percent,
      confirmInvoiceDescription: item.confirmInvoiceDescription
    } as CalibrationConfirmInvoiceDeviceModel;

    this.savingIndex = index;
    this.service.SaveDetail(model, this.calibrationId)
      .pipe(finalize(() => this.savingIndex = null))
      .subscribe(
        response => {
          if (response === false) {
            this.alertifyService.ErrorMessage('ذخیره اطلاعات تجهیز مجاز نیست.');
            return;
          }
          this.alertifyService.SuccessMessage('اطلاعات تجهیز ذخیره شد.');
          this.savedDetails.set(item.id, JSON.stringify(item));
          this.calculateTotals();
        },
        () => this.alertifyService.ErrorMessage('ذخیره اطلاعات تجهیز با خطا مواجه شد.')
      );
  }

  get canConfirmFinal(): boolean {
    if (!this.receipt) {
      return true;
    }

    const confirmedCount = Number(this.receipt.confirmedDeviceCount);
    const totalCount = Number(this.receipt.totalDeviceCount);
    return !isFinite(confirmedCount) || !isFinite(totalCount) || confirmedCount === totalCount;
  }

  openConfirmModal(template: TemplateRef<any>): void {
    if (this.confirming || !this.calibrationId) {
      return;
    }

    if (this.hasUnsavedChanges || this.savingIndex !== null) {
      this.alertifyService.ErrorMessage('ابتدا تغییرات دستگاه‌ها را ذخیره کنید.');
      return;
    }

    if (!this.canConfirmFinal) {
      this.alertifyService.ErrorMessage('ابتدا تمام تجهیزات رسید تایید کار شوند');
      return;
    }

    this.confirmModalRef = this.modalService.show(template);
  }

  submitFinalConfirm(): void {
    if (this.confirming || this.hasUnsavedChanges || this.savingIndex !== null) {
      return;
    }

    this.confirmModalRef.hide();
    this.confirming = true;
    this.service.Confirm(this.calibrationId, this.totals.finalTotal)
      .pipe(finalize(() => this.confirming = false))
      .subscribe(
        response => {
          if (response === false) {
            this.alertifyService.ErrorMessage('تایید رسید مجاز نیست.');
            return;
          }
          this.alertifyService.SuccessMessage('رسید و پیش فاکتور با موفقیت تایید شد.');
          this.router.navigate(['/CalibrationConfirmInvoice']);
        },
        () => this.alertifyService.ErrorMessage('تایید نهایی با خطا مواجه شد.')
      );
  }

  getUnitPrice(item: CalibrationConfirmInvoiceDeviceModel): number {
    return calculateCalibrationUnitPrice(item);
  }

  getFinalT4(item: CalibrationConfirmInvoiceDeviceModel): number {
    const t4 = this.toNumber(item.t4);
    return t4
      + this.toNumber(item.incT4)
      + t4 * this.toNumber(item.incT4Percent) / 100;
  }

  getInvoiceTotal(item: CalibrationConfirmInvoiceDeviceModel): number {
    return calculateCalibrationInvoiceTotal(item);
  }

  getFinalTotal(item: CalibrationConfirmInvoiceDeviceModel): number {
    return calculateCalibrationFinalTotal(item);
  }

  getGrandTotal(): number {
    return this.totals.subTotal;
  }

  getFinalGrandTotal(): number {
    return this.totals.finalTotal;
  }

  calculateTotals(): void {
    this.totals = calculateCalibrationTotals(this.details, this.khadamat, this.takhfif, this.arshAfzoodeh);
  }

  private toNumber(value: number | null | undefined): number {
    const numericValue = Number(value);
    return isFinite(numericValue) ? numericValue : 0;
  }

  private unwrap<T>(response: T[] | CalibrationConfirmInvoiceApiResponse<T[]>): T[] {
    if (Array.isArray(response)) { return response; }
    return response && Array.isArray(response.result) ? response.result : [];
  }
}
